import PersonIcon from "@mui/icons-material/Person";
// import { Box, Button, Typography, Modal, Grid } from "@mui/material";

import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  FormControl,
  Container,
  Grid,
  Box,
  Stack,
  OutlinedInput,
  InputLabel,
  MenuItem,
  ListItemText,
  Select,
  Checkbox,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  Modal,
  DialogTitle,
  Tabs,
  Tab,
  Switch,
  FormGroup,
} from "@mui/material";

import {
  addEmployee,
  getNewSubscriptionReachageDetails,
  updateEmployee,
} from "./appoinmentDashboardApi";
import { payloadDateFormat, swalAlertPopProps } from "../../utils/commonUtils";
import { getDataRechageDetail } from "./smbAccountRechargeCustomApiHandler";
import { getMonthDifference } from "./smbAccounrReachargeDateFunction";
import CloseIcon from "@mui/icons-material/Close";
import { getAlldetailSerice } from "../services/servicesListApi";

// import "./test.css";

import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
// import { bookApoinment } from "./asppoinmentApi";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { routePath } from "../../constants/routePath";
import { setSession } from "../../utils/commonUtils";
import { setCustomerAppointmentId } from "../../app/store/reducer";
// import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { validationPersonalInfo } from "../payment/validation";
import Swal from "sweetalert2";
import ImageUploader from "../../common/imageUpload";
import { TextFieldSearch } from "../../common/fieldText";
import PoprchModal from "../payment/popSearch";
import { UpdateProfile, addProfile, getGusinessProfile } from "./busnessProfileModalapi";
import { ModalHeader } from "../../common/modalHeader";
import MediaCardInput from "../../common/mediaCardInput";
// import { getAlldetailSerice } from "../services/servicesListApi";

dayjs.extend(utc);
dayjs.extend(timezone);

export default function                           


ElegentProfileModal({
  open,
  setOpen,
  modalData,
  getAll,
}) {
  const userDetail = useSelector((state) => state.reducer.userDetail);
   const onCloseFn=()=>{
    setOpen(false)
   }
  return (
    <Modal
      open={open}
      onClose={onCloseFn}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 500,
          bgcolor: "background.paper",
          borderRadius: "8px",
          boxShadow: 24,
          p: "10px",
          overflowY: "auto",
          height: "30vh",
        }}
      >
        <ModalHeader            title="Elegent Prime Profile Link"  onClose={(data)=>{
          setOpen(data)
        }}/>

        <Box sx={{ mt: 4, my: 5 }} display="flex" justifyContent="center">
        <MediaCardInput
                title={"Profile Id"}
                url={userDetail?.profileId} iIcon={<PersonIcon/>} value={userDetail?.profileId} setValue={() => { }} />
        </Box>
      </Box>
    </Modal>
  );
}
